import { each } from 'lodash-es';

import {
  ACCESS_ROUTED,
  ACCESS_DIRECT,
  NETWORK_TYPES,
  NETWORK_PHYSICAL_TYPES
} from '@/common/constants/networks.constants';

export function subnetTranslator(subnet) {
  return {
    allocation_pools: subnet.pools
      ?.filter(it => !it.deleted)
      .map(it => ({ start: it.startAddress, end: it.endAddress })) || [],
    cidr: subnet.cidr || undefined,
    dns_nameservers: subnet.dns?.map(it => it.value) || [],
    enable_dhcp: subnet.dhcp,
    gateway_ip: subnet.gatewayIp || null,
    id: subnet.id, // not updating
    ip_version: subnet.ipVersion, // not updating
    // network_id: subnet.networkId,
    ipv6_ra_mode: subnet.ipv6RaMode || undefined,
    ipv6_address_mode: subnet.ipv6AddressMode || undefined,
  };
}

export function subnetsTranslator(form) {
  return form.subnets.map(subnet => subnetTranslator(subnet));
}

function accessActionsTranslator(options) {
  if (options === 'full') {
    return [ACCESS_DIRECT, ACCESS_ROUTED];
  }
  return [options];
}

function physicalNetworkTranslator(form) {
  if (form.config.network.vlan > 0) {
    return { vlan_network: form.config.network.name };
  }
  return { physical_network: form.config.network.name };
}

export function accessTranslator(form) {
  const result = [];
  if (form.access.all) {
    result.push({
      target_project: '*',
      actions: accessActionsTranslator(form.access.allOptions)
    });
  } else {
    each(form.access.domains, (domain) => {
      each(domain.projects, (project, projectId) => {
        result.push({
          target_project: projectId,
          actions: accessActionsTranslator(project.options)
        });
      });
    });
  }

  return result;
}

export default function (form) {
  let type;
  let network = {
    name: form.config.name,
    subnet: form.config.ip_management && form.subnet ? subnetTranslator(form) : undefined,
    subnets: form.config.ip_management && form.subnets ? subnetsTranslator(form) : undefined,
    rbac_policies: accessTranslator(form)
  };

  if (form.config.type === NETWORK_TYPES.PHYSICAL) {
    network = {
      ...network,
      ...physicalNetworkTranslator(form),
      mtu: form.config.mtu
    };

    if (form.config.physicalType === NETWORK_PHYSICAL_TYPES.VLAN) {
      type = NETWORK_PHYSICAL_TYPES.VLAN;
      network = {
        ...network,
        vlan_id: form.config.vlan_id
      };
    }

    if (form.config.physicalType === NETWORK_PHYSICAL_TYPES.UNTAGGED) {
      type = 'public';
    }
  } else {
    type = 'private';
  }

  return {
    type,
    network
  };
}
